import hampton1 from "./hampton (1).png";
import hampton2 from "./hampton (2).png";
import hampton3 from "./hampton (3).png";

const hamptonnew = [hampton1, hampton2, hampton3];

export default hamptonnew;
